var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canRoute(_vm.to))?_c('router-link',{staticClass:"link-if-can",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('span',{staticClass:"link-if-can"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }